import './RatingStars.css'

const RatingStars = ({ rating, onRatingChange, readOnly = false, size = 'medium' }) => {
  const handleClick = (value) => {
    if (!readOnly && onRatingChange) {
      onRatingChange(value)
    }
  }

  return (
    <div className={`rating-stars rating-stars-${size} ${readOnly ? 'read-only' : ''}`}>
      {[1, 2, 3, 4, 5].map((value) => (
        <span
          key={value}
          className={`star ${value <= (rating || 0) ? 'filled' : ''}`}
          onClick={() => handleClick(value)}
          role={readOnly ? 'img' : 'button'}
          aria-label={`${value} estrella${value !== 1 ? 's' : ''}`}
          tabIndex={readOnly ? -1 : 0}
        >
          ★
        </span>
      ))}
    </div>
  )
}

export default RatingStars

